
export default function AboutData() {
    return {
        title: "About Term Life Insurance",
        content: 'Term life insurance is a product that clients can utilize to protect their family in the event they pass away prematurely. Think renting, not buying. Term life insurance is often the most affordable coverage because it offers protection for a specific number of years. Term life insurance can also be used as a tool for business owners who want to insure key employees or arrange for a buy/sell agreement.',
    }
}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/term/AboutData.js